const getSiblings = function (e) {
  // for collecting siblings
  const siblings = [];
  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }
  // first child of the parent node
  let sibling = e.parentNode.firstChild;

  // collecting siblings
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

// Show/Close Popups

const sizeChartTriggers = document.querySelectorAll(".js-size-chart-trigger");
const popups = document.querySelectorAll(".popup-size-chart");

if (popups.length !== 0) {
  sizeChartTriggers.forEach((el) => {
    el.classList.remove("hidden");
  });
}

if (popups.length !== 0) {
  sizeChartTriggers[0].addEventListener("click", function (e) {
    e.preventDefault();
    const parentFieldset = this.closest("fieldset");
    const currentFabricValue = parentFieldset
      ?.querySelector(".standard-radios input:checked")
      ?.value.toLowerCase();
    const tabTarget = popups[0].querySelector(
      `[data-handle="${currentFabricValue}"]`,
    );
    tabTarget?.click();
    popups[0].classList.add("is-active");
  });

  popups.forEach((popup) => {
    const popupCloseBtn = popup.querySelector(".popup__close");
    const popupCloseBg = popup.querySelector(".popup__close-bg");

    popupCloseBtn.addEventListener("click", function (e) {
      e.preventDefault();

      this.closest(".popup-size-chart").classList.remove("is-active");
    });

    popupCloseBg.addEventListener("click", function (e) {
      e.preventDefault();

      this.closest(".popup-size-chart").classList.remove("is-active");
    });
  });
}

if (popups.length === 2) {
  sizeChartTriggers[2].addEventListener("click", function (e) {
    e.preventDefault();
    const parentFieldset = this.closest("fieldset");
    const currentFabricValue = parentFieldset
      ?.querySelector(".standard-radios input:checked")
      ?.value.toLowerCase();
    const tabTarget = popups[1].querySelector(
      `[data-handle="${currentFabricValue}"]`,
    );
    tabTarget?.click();
    popups[1].classList.add("is-active");
  });
}

// Switching between popup tabs

if (popups.length !== 0) {
  popups.forEach((popup) => {
    const tabLinks = popup.querySelectorAll(".tabs-charts .tabs__head a");

    if (tabLinks.length > 0) {
      tabLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          const thisParent = this.parentNode;
          const parentSiblings = getSiblings(thisParent);
          const href = this.getAttribute("href");

          thisParent.classList.add("is-active");
          parentSiblings.forEach((sibling) => {
            sibling.classList.remove("is-active");
          });

          const target = document.querySelector(href);
          const targetSiblings = getSiblings(target);

          target.classList.add("is-active");
          targetSiblings.forEach((sibling) => {
            sibling.classList.remove("is-active");
          });
        });
      });
    }
  });
}

// Switching from IN to CM

if (popups.length !== 0) {
  popups.forEach((popup) => {
    const scaleCharts = popup.querySelectorAll(".popup-size-chart table em");
    const changeMeasure = popup.querySelector(".js-chart-scale");

    if (scaleCharts.length > 0) {
      scaleCharts.forEach((chart) => {
        const chartValue = chart.textContent;
        chart.setAttribute("data-in", chartValue);

        if (chartValue.includes("-")) {
          const splitChartValueArray = chartValue.split("-");

          chart.setAttribute(
            "data-cm",
            `${Math.round(parseInt(splitChartValueArray[0], 10) * 2.54)} - ${Math.round(parseInt(splitChartValueArray[1], 10) * 2.54)}`,
          );
        } else {
          chart.setAttribute(
            "data-cm",
            `${Math.round(parseInt(chartValue, 10) * 2.54)}`,
          );
        }
      });

      changeMeasure.addEventListener("change", function () {
        if (this.checked) {
          scaleCharts.forEach((chart) => {
            const cm = chart.getAttribute("data-cm");
            chart.textContent = cm; // eslint-disable-line
          });
        } else {
          scaleCharts.forEach((chart) => {
            const inc = chart.getAttribute("data-in");
            chart.textContent = inc; // eslint-disable-line
          });
        }
      });
    } else {
      popup.querySelector(".switch-container").classList.add("!hidden");
    }
  });
}
